
import { createAction } from '@ywxk/pinia/utils'
export interface dataStoreType {
  isReady: boolean
}

// 普通数据
const INITNORMAL = {
  isReady: false
}
// 需冻结复杂数据
const INITFREEZE = {}

// 初始化state
const initState = (): dataStoreType => Object.assign({}, INITNORMAL, INITFREEZE)

const dataStore = defineStore('data', {
  state: initState,
  actions: {
    ...createAction(Object.keys(INITNORMAL)),
    ...createAction(Object.keys(INITFREEZE), { isFreeze: true }),
  }
})

export default dataStore
